import React, { useState, useEffect } from 'react';
import { Typography, Grid2, Link } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import { httpRequest } from '../../ui-utils/api';
import loadergif from '../../Assets/Images/app_downloads_loader.gif';
import styles from './Circular.module.css';
import axios from 'axios';
import DocumentMeta from 'react-document-meta'

const meta = {
    title: 'Circulars | Latest NSE, BSE & CDSL Updates | TradeBoss',
    description: 'Stay informed with the latest TradeBoss circulars and notices from NSE, BSE & CDSL. Access key trading and compliance updates here.',
    canonical: 'https://tradeboss.co/holiday_calendar, https://tradeboss.co/circular,  https://tradeboss.co/issue_disclosures, https://tradeboss.co/bulletin',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'NSE circulars, BSE circulars, trade circulars India, regulatory notices trading, market circular updates'
        }
    }
}

const Circular = () => {
    const [userdata, setUserdata] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [hidenext, setHidenext] = useState(true);
    const [hideprev, setHideprev] = useState(true);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoad(true);
            try {
                const cir_data = await axios.post(`https://bullforce-trader-admin-backend.bullforce.co/api/circulars/list`)
                setUserdata(cir_data.data.data);
                setTotalPages(cir_data.data.totalPages);
                setHidenext(false);
                setLoad(false);
            } catch (error) {
                setLoad(false);
                console.log('An Error Occurred');
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const updateData = async () => {
            console.log("page",page)
            try {
                const payload = { page };
                const cir_data =await axios.post(`https://bullforce-trader-admin-backend.bullforce.co/api/circulars/list`,payload)
                  console.log("uuuCircular data",cir_data.data.data)
                setUserdata(cir_data.data.data);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            } catch (error) {
                setLoad(false);
                console.log('An Error Occurred', error);
            }
        };
        if (page !== 1) {
            updateData();
        }
    }, [page]);

    const pagination = (value) => {
        if (value === 'previous') {
            if (page === totalPages - 1) {
                setPage((prev) => prev + 1);
                setHideprev(false);
            } else if (page < totalPages) {
                setPage((prev) => prev + 1);
                setHidenext(true);
            }
        } else if (value === 'next') {
            if (page === 2) {
                setPage((prev) => prev - 1);
                setHidenext(false);
            } else if (page !== 1) {
                setPage((prev) => prev - 1);
                setHideprev(true);
            }
        }
    };

    return (
        <div id="Grid2Top" style={{ width: '100%', marginTop: '25px', height: 'auto' }}>
            <DocumentMeta {...meta} />
            {load ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <img src={loadergif} alt="loading..." style={{ height: '100px', width: '100px' }} />
                </div>
            ) : (
                <>
                    <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px', flexDirection: 'column' }}>
                        <Grid2 className={styles.cir_card1}>
                            {userdata.map((label, index) => (
                                <Grid2 key={index} style={{ width: '100%', display: 'flex', background: '#ffffff', alignItems: 'center', padding: '20px 2px', borderTop: '1.5px solid #DFE0EB' }}>
                                    <Grid2 className={styles.cir_card3}>
                                        <Typography className={styles.tit_label_date}>{label.c_date}</Typography>
                                        <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <Grid2 style={{
                                                width: '100px', padding: '4px', background: '#F2F2F2', borderRadius: '4px', marginTop: '5px', whiteSpace: "normal" }}>
                                                <Typography className={styles.tit_label}>{label.exchange}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 className={styles.cir_card4}>
                                        <Typography
                                            className={styles.tit_label1}
                                            onClick={(e) => window.open(label.link, '_blank')}
                                            sx={{ whiteSpace: "normal", textAlign: "justify", lineHeight: "1.5",paddingRight:"15px" }}
                                        >
                                            {label.subject}
                                        </Typography>
                                    </Grid2>
                                </Grid2>
                            ))}
                            <Grid2 style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                {hideprev && (
                                    <Grid2>
                                        <Link display="flex" className={styles.buttonGridBig} onClick={() => pagination('previous')}>
                                            <ArrowBackIcon sx={{ marginRight: '8px' }} /> Previous
                                        </Link>
                                    </Grid2>
                                )}
                                {hidenext && (
                                    <Grid2 sx={{ margin: '0px 15px ' }}>
                                        <Link display="flex" className={styles.buttonGridBig} onClick={() => pagination('next')}>
                                            Next <ArrowForwardIcon sx={{ marginLeft: '8px' }} />
                                        </Link>
                                    </Grid2>
                                )}

                            </Grid2>
                        </Grid2>
                    </Grid2>
                </>
            )}
        </div>
    );
};

export default Circular;